import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1f2220] text-[#F8F5F0]/70 py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="font-serif text-3xl text-[#F8F5F0] tracking-tight">
              Villa Sućuraj
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed font-light">
              {t.footer.tagline}
            </p>
          </div>
          <div className="md:col-span-6">
            <div className="text-xs uppercase tracking-[0.24em] text-[#C05C3D] font-semibold">
              {t.footer.contact}
            </div>
            <ul className="mt-6 space-y-4 text-sm font-light">
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-[#F8F5F0]/50" />
                {t.footer.address}
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#F8F5F0]/50" />
                <a
                  href="mailto:stay@villasucuraj.com"
                  className="hover:text-[#F8F5F0] transition-colors"
                  data-testid="footer-email"
                >
                  stay@villasucuraj.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#F8F5F0]/50" />
                <span>+385 (0) 21 000 000</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F8F5F0]/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs uppercase tracking-[0.22em]">
          <span>© {year} Villa Sućuraj</span>
          <span>{t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
};
